import style from "./needhelp.module.css";

const Concerned = () => {
  return (
    <div className={style.content}>
      <div className={`p-3 bg-white rounded ${style.articleScroll}`}>
        <div className="">
          <div className=" fw-bold">
            Concerned About a Campaign? Here's What to Do
          </div>
          <div className=" mt-1 fs14 text-black">
            At FundLife, we’re committed to stewarding a platform that reflects
            integrity, trust, and the hope of Jesus. If you come across a
            campaign that seems suspicious or potentially violates our Terms of
            Use, we invite you to report it for review
          </div>
        </div>
        <div className="mt-4">
          <div className=" text-black">How to Report a Campaign</div>
          <div className="fs14 mt-2">
            To ensure your report reaches the right team, please follow these
            steps:
          </div>
          <ul className="mt-2">
            <li className="fs14">
              Click the Contact Us button at the bottom-right of this page
            </li>
            <li className="fs14">
              Choose Report a Campaign as your reason for reaching out
            </li>
            <li className="fs14">
              Include the campaign URL and a brief explanation of your concern
            </li>
          </ul>
        </div>
        <div className="mt-4">
          <div className=" text-black">When Can I Report a Campaign?</div>
          <div className="fs14 mt-2">
            If something doesn’t seem right, you can report a campaign for any
            of the following reasons:
          </div>
          <ul className="mt-2">
            <li className="fs14">Suspected false or misleading information</li>
            <li className="fs14">Potential fraud or scam</li>
            <li className="fs14">Campaign appears to fund illegal activity</li>
            <li className="fs14">Violations of our Terms of Use</li>
          </ul>
        </div>
        <div className="mt-4">
          <div className=" text-black">What Happens Next</div>
          <div className="fs14 mt-2">Once your report is submitted:</div>
          <ul className="mt-2">
            <li className="fs14">We'll conduct a confidential review</li>
            <li className="fs14">
              If we find a violation has occurred, we’ll take appropriate action
            </li>
            <li className="fs14">
              For privacy reasons, we cannot disclose the outcome of individual
              reports
            </li>
          </ul>

          <div className="fs14 mt-3">
            To better understand our values and how we handle sensitive topics,
            check out our article Why We Allow Some Campaigns You May Disagree
            With | Our Principles & Policy.
          </div>
        </div>
        <div className="mt-4">
          <div className=" text-black">Upholding Integrity, Thanks to You</div>
          <div className="fs14 mt-2">
            Your willingness to report concerns plays an important role in
            helping us protect the integrity of FundLife. Every report helps us
            uphold a space built on transparency, accountability, and trust —
            and we’re grateful for the care you show in keeping our platform
            strong for everyone.
          </div>
        </div>
        <div className="mt-4">
          <div className=" text-black">Still Need Help?</div>
          <div className="fs14 mt-2">
            Still need help? Click the Contact Us button at the bottom right of
            the page to get in touch with our team.
          </div>
        </div>
      </div>
    </div>
  );
};

export default Concerned;
